// Ensure Alpine and xPopup store exist before Quick View logic runs
document.addEventListener('alpine:init', () => {
  if (!Alpine.store('xPopup')) {
    Alpine.store('xPopup', {
      open: false,
      openPopup() { this.open = true },
      close() { this.open = false }
    });
  }
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,

      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: {},        // changed from []
      cachedfetch: {},          // changed from []
      loadingUrls: [],
      loadedChooseOptions: {},
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      buttonQuickView: "",

      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = {};
        });
      },

      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },

      load(url, el, optionId) {
        if (this.buttonQuickView === '') {
          this.buttonQuickView = el;
        }

        const variantEl = document.getElementById('current-variant-' + optionId);
        const variant = variantEl ? variantEl.innerText.trim() : '';
        let productUrl = variant
          ? `${url}?variant=${variant}&section_id=${this.sectionId}`
          : `${url}?section_id=${this.sectionId}`;
        productUrl = productUrl.replace(/\s+/g, '');

        // use cache if available
        if (this.cachedResults[productUrl]) {
          const quickViewEl = document.getElementById('quickview-product-content');
          quickViewEl.innerHTML = this.cachedResults[productUrl];
          return true;
        }

        // prevent duplicate fetches
        if (this.cachedfetch[productUrl]) return true;

        this.loading = true;
        this.cachedfetch[productUrl] = true;

        fetch(productUrl)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(response, 'text/html');
            const contentEl = parsed.getElementById('quickview-product-content');
            if (!contentEl) {
              console.warn('QuickView: missing quickview-product-content in response');
              return;
            }

            const content = contentEl.innerHTML;
            const quickViewEl = document.getElementById('quickview-product-content');
            if (quickViewEl) quickViewEl.innerHTML = content;

            // fire lifecycle event
            document.dispatchEvent(new CustomEvent('QuickView:open', {
              detail: { container: quickViewEl }
            }));

            // ensure variant description script runs
            if (typeof initVariantDescriptions === 'function') {
              initVariantDescriptions(quickViewEl);
            }

            this.cachedResults[productUrl] = content;
          })
          .catch(err => console.error('QuickView load error:', err))
          .finally(() => {
            this.loading = false;
            this.cachedfetch[productUrl] = false;
          });

        return true;
      },

      async loadChooseOptions(url, el, optionId, index) {
        const variantEl = document.getElementById('current-variant-' + optionId);
        const getVariant = variantEl ? variantEl.innerText.trim() : '';
        const urlProduct = getVariant
          ? `${url}?variant=${getVariant}&section_id=choose-option&page=${index}`
          : `${url}?section_id=choose-option&page=${index}`;

        const destinationElm = document.getElementById('choose-options-' + optionId)?.querySelector('.choose-options');
        const destinationElmMobile = document.getElementById('choose-options-mobile');
        const loadingEl = document.getElementById('choose-options-' + optionId)?.querySelector('.icon-loading');

        if (this.loadedChooseOptions[urlProduct]) {
          if (window.innerWidth > 767) {
            destinationElm.innerHTML = this.loadedChooseOptions[urlProduct];
            destinationElmMobile.innerHTML = '';
          } else {
            destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct];
            destinationElm.innerHTML = '';
          }
          return true;
        }

        try {
          if (loadingEl) loadingEl.classList.remove('hidden');
          this.loadingChooseOption = true;

          if (!this.loadingUrls.includes(urlProduct)) {
            this.loadingUrls.push(urlProduct);
            await fetch(urlProduct)
              .then(response => response.text())
              .then(content => {
                const parser = new DOMParser();
                const parsed = parser.parseFromString(content, 'text/html');
                const parsedContent = parsed.getElementById('choose-options-content')?.innerHTML;

                if (parsedContent) {
                  if (window.innerWidth > 767) {
                    destinationElmMobile.innerHTML = '';
                    destinationElm.innerHTML = parsedContent;
                  } else {
                    destinationElmMobile.innerHTML = parsedContent;
                    destinationElm.innerHTML = '';
                  }
                  this.loadedChooseOptions[urlProduct] = parsedContent;
                }
                if (loadingEl) loadingEl.classList.add('hidden');
              })
              .finally(() => {
                const idx = this.loadingUrls.indexOf(urlProduct);
                if (idx !== -1) this.loadingUrls.splice(idx, 1);

                const desktop = window.innerWidth > 767 ? destinationElm : destinationElmMobile;
                if (desktop?.querySelector('.add_to_cart_button')) {
                  desktop.querySelector('.add_to_cart_button').style.display = 'block';
                }
                if (desktop?.querySelector('.label-btn-quickview')) {
                  desktop.querySelector('.label-btn-quickview').style.display = 'none';
                }
              });
          }
          this.loadingChooseOption = false;
        } catch (error) {
          console.error('QuickView loadChooseOptions error:', error);
        }
      },

      open(isMiniCart = false) {
        this.show = true;
        this.isMiniCart = isMiniCart;
        if (Alpine.store('xPopup')) Alpine.store('xPopup').open = true;
      },

      close() {
        this.show = false;
        this.buttonQuickView = '';
        const miniCart = Alpine.store('xMiniCart');
        if (!miniCart || !miniCart.open) {
          if (Alpine.store('xPopup')) Alpine.store('xPopup').close();
        }
      },

      focusQuickView(quickView, btnClose) {
        if (!this.selected && Alpine.store('xFocusElement')) {
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
        }
      },

      removeFocusQuickView() {
        if (!this.selected && Alpine.store('xFocusElement')) {
          const elementActive = document.getElementById('button_quickview');
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },

      closePopupMobile() {
        this.openPopupMobile = false;
      },

      showChooseOption(id, el) {
        this.openPopupMobile = true;
        const product = el.closest('.card-product');
        const addToCartBtn = product.querySelector('.choose-options')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options')?.querySelector('.label-btn-quickview');
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.label-btn-quickview');

        if (addToCartBtn && iconAddToCartBtn && window.innerWidth > 767) {
          addToCartBtn.style.display = 'block';
          iconAddToCartBtn.style.display = 'none';
        } else if (addToCartBtnMobile && iconAddToCartBtnMobile) {
          addToCartBtnMobile.style.display = 'block';
          iconAddToCartBtnMobile.style.display = 'none';
        }
      },

      clickInsideQuickView(evt, $el) {
        if (this.isMiniCart) {
          evt.stopPropagation();
          this.show = false;
          if (Alpine.store('xPopup')) Alpine.store('xPopup').close();
        }
      },

      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      }
    });

    // Allow closing with ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && Alpine.store('xQuickView')?.show) {
        Alpine.store('xQuickView').close();
      }
    });
  });
});
